


































import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'

interface KeyValueObj {
  key: string
  value: string
  checked: boolean
}

@Component
export default class KeyValueEditor extends Vue {
  @Prop({ required: false, default: '' }) private title!: string
  @Prop({ required: false, default: '100%' }) private maxHeight!: string
  @Prop({ required: false, default: false }) private disabled!: boolean
  @Model('change', { type: Object }) private readonly value!: ClientPropertiesModel['userProperties'] | null

  private dataList: KeyValueObj[] = []

  @Watch('value')
  private handleValueChanged(
    val: ClientPropertiesModel['userProperties'],
    oldVal: ClientPropertiesModel['userProperties'],
  ) {
    if (oldVal === undefined && val) {
      this.processObjToArry()
    }
  }

  private handleInputChange() {
    const checkedList = this.dataList.filter((pair) => pair.checked)
    const objData: ClientPropertiesModel['userProperties'] = {}
    checkedList.forEach(({ key, value }) => {
      if (key === '') return
      const objValue = objData[key]
      if (objValue) {
        const _value = value as string
        if (Array.isArray(objValue)) {
          objData[key] = [...objValue, _value]
        } else {
          objData[key] = [objValue, _value]
        }
      } else {
        objData[key] = value
      }
    })
    this.$emit('change', objData)
  }

  private addItem() {
    this.dataList.push({ key: '', value: '', checked: true })
  }
  private deleteItem(index: number) {
    if (this.dataList.length > 1) {
      this.dataList.splice(index, 1)
      this.handleInputChange()
    } else if (this.dataList.length === 1) {
      this.dataList = [{ key: '', value: '', checked: true }]
      this.$emit('change', null)
    }
  }
  private checkItem(index: number) {
    this.dataList[index].checked = !this.dataList[index].checked
    this.handleInputChange()
  }

  private processObjToArry() {
    if (this.value === undefined || this.value === null) {
      this.dataList = [{ key: '', value: '', checked: true }]
      return
    }
    this.dataList = []
    Object.entries(this.value).forEach(([key, value]) => {
      if (typeof value === 'string') {
        this.dataList.push({ key, value, checked: true })
      } else {
        value.forEach((item) => {
          this.dataList.push({ key, value: item, checked: true })
        })
      }
    })
  }

  private created() {
    this.processObjToArry()
  }
}
